export default "__VITE_ASSET__k7bYao2M__"